
export const MENU_ORDER_TEXT = 'Orders';
export const MENU_STORE_TEXT = 'Stores';
export const MENU_PAYMENTS_TEXT = 'Payments';
export const MENU_SETTINGS_TEXT = 'Settings';
export const MENU_LOGOUT_TEXT = 'Log Out';

//Adminflow 
export const HOME_TEXT = 'Home';
export const ACTIVATION_TEXT = 'IACM/Otter Activation'; 
export const ADMIN_CREATION = 'Admin Creation'; 
export const CREATEACCOUNT_TEXT = 'Create Account';
export const CREATEACCOUNTS_TEXT = 'Create Account';
export const ADMINACCOUNT_TEXT= 'Admin Account';
export const AGGREGRATOR_TEXT = 'IACM/OTTER';
export const MERCHANT_TEXT = 'STREAM/OLO';
export const MANAGEMERCHANT_TEXT='Manage Merchants';
export const MERCHANTACC_TEXT='Merchant Account';
